<template>
  <div class="gallery-item position-relative">
    <!-- pdf v-if="!isLoading && document.url && !isNotPdf" :id="document.url" :key="document.url" class="doc" style="width:93px;"
      :resize="true" :src="document.url" :page="1">
      <template #loading>
        Cargando...
      </template>
    </pdf-->
    <div v-if="!isLoading && image != null" class="img">
      <img :src="image" alt="" style="opacity: 0.6">
    </div>
    <div v-if="isLoading" class="text-center">
      <div class="spinner-border spinner-size" role="status">
        <span class="visually-hidden fs-1">{{ $t('key_loading') }}</span>
      </div>
    </div>
    <a style="cursor:pointer" :title="$t('key_delete')" class="remove-item" @click="updateDoc(document)">
      <i class="fa-solid fa-window-close"></i>
    </a>
    <a style="cursor:pointer" :title="$t('key_download')" class="download-document-resource" @click="download(document)">
      <i class="fa-solid fa-download"></i>
    </a>
    <div class="img-info">
      <div class="img-name" :title="getDocumentName(document.name)">{{ getDocumentName(document.name) }}</div>
      <div class="img-size">{{ $dateUtils.toDDMMYYYYHH(document.date) }}</div>
    </div>
  </div>
</template>

<script>

  import defaultImage from "@/assets/img/logos/default.png";

  export default {
    name: "DocumentItem",
    components: {
      // pdf,
    },
    props: {
      index: {
        type: Number,
        required: true
      },
      document: {
        type: Object,
        required: true
      },
      errorRemove: {
        type: Object,
        default: () => {
          return null;
        },
      },
      successRemove: {
        type: Object,
        default: () => {
          return null;
        },
      },
      errorDownload: {
        type: Object,
        default: () => {
          return null;
        },
      },
      successDownload: {
        type: Boolean,
        default: () => {
          return null;
        },
      },
      confirmDelete: {
        type: Boolean,
        default: () => {
          return false;
        },
      },
    },
    emits: ['switch', 'remove', 'download', 'loaded', 'request-remove'],
    data() {
      return {
        isLoading: false,
        image: null,
        excelFileTypes: [
          '.xlsx', '.xlsm', '.xlsb', '.xltx', '.xltm',
          '.xlt', '.xml', '.xlam', '.xla', '.xlw', '.xlr', '.xls',
        ]
      }
    },
    computed: {},
    watch: {
      document() {
        if (this.document) {
          this.isLoading = false
        }
      },
      errorRemove() {
        if(this.errorRemove) {
          this.isLoading = false
        }
      },
      errorDownload() {
        if(this.errorDownload) {
          this.isLoading = false
        }
      },
      successRemove() {
        if(this.successRemove) {
          this.isLoading = false
        }
      },
      successDownload() {
        if(this.successDownload) {
          this.isLoading = false
        }
      },
      confirmDelete() {
        if(!this.confirmDelete && typeof this.confirmDelete != 'boolean') {
          this.isLoading = false
        }
      },
    },
    mounted() {
      if (this.document) {
        const type = this.getType()

        Object.keys(this.$resourceMapper).forEach(key => {
          const formats = this.$resourceMapper[key]['formats']
          if (formats.length > 0 && formats.includes(type)) {
            this.image = this.$resourceMapper[key]['logo']
          }
        })
        if (!this.image) {
          this.image = defaultImage
        }
      }
    },
    methods: {
      updateDoc(img) {
        // this.isLoading = true
        this.$emit('request-remove', img)
      },
      remove(doc) {
        this.isLoading = true
        this.$emit('remove', doc)
      },
      download(value) {
        this.isLoading = true
        this.$emit('download', value)
      },
      getDocumentName(value) {
        const name = value.split('/')[2]
        return name
      },
      getType() {
        const currentIndex = this.getIndex()

        if (currentIndex == null) return currentIndex

        const nameLength = this.document.name.length
        const fileType = this.document.name.substring(currentIndex, nameLength)
        return fileType
      },
      getIndex() {
        let index = null
        let currentIndex = null
        
        while(index == 0 || index >= 0) {
          if (index == null) {
            index = this.document.name.indexOf('.')
          } else {
            index = this.document.name.indexOf('.', index + 1)
          }

          if (index >= 0) {
            currentIndex = index
          }
        }

        return currentIndex
      }
    },
  };

</script>

<style lang="scss">

  .spinner-size {
    width: 3rem;
    height: 3rem;
  }

  .remove-item {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 0.1rem;
    left: 7.5rem;
    font-size: 1.5rem;
  }

  .download-document-resource {
    display: none;
    cursor: pointer;
    position: absolute;
    top: 0.1rem;
    left: 1rem;
    font-size: 1.5rem;
  }

  $primColor: #F2F3F4;
  $secTextColor: black;

  .gallery {
    //display: flex;
    flex: auto;
    flex-wrap: wrap;
    align-items: center;
    justify-content: left;
    // margin: 0 0 -0.5rem 1.5rem;
    margin-left: .2rem;

    .gallery-new-item {
      height: 176px;
      // width: 180px;
      padding: 0rem;
      margin: 0 0.5rem 1rem 0.5rem;

      overflow: hidden;
      display: inline-table;
      grid-template-rows: 70% 30%;
      align-items: center;
      justify-content: center;

      border-radius: 5px;
    }

    .gallery-item {
      height: 175px;
      width: 154px !important;
      padding: 0rem;
      justify-items: center;
      margin: 0 0.5rem 1rem 0.5rem;

      overflow: hidden;
      display: inline-grid;
      grid-template-rows: 70% 30%;
      align-items: center;
      justify-content: center;

      border-radius: 5px;
      background-size: cover;
      background-color: #F2F3F4;

      .img {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          object-fit: cover;
          width: 100%;
          height: 100%;
        }
      }

      .img-info {
        padding: 0.5rem 0;
        overflow: hidden;
        text-align: center;
        width: 100%;
        background-color: #F2F3F4;

        .img-name {
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 0.875rem;
          color: black;
          max-width: 190px;
          overflow: hidden;
          padding: 0 0.5rem;
        }

        .img-size {
          font-size: 0.75rem;
          color: black;
          text-align: center;
          padding: 0 1rem;
        }
      }
    }

    .gallery-item:hover .doc {
      opacity: 0.5;
    }

    .gallery-item:hover .remove-item {
      display: block;
      color: #4A7062
    }

    .gallery-item:hover .download-document-resource {
      display: block;
      color: #4A7062
    }
  }

</style>
